import React from 'react';
import { Link } from 'react-router-dom';
import './ButtonLink.css';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';

export const InvertedButtonLink = (props, context) => (
  <Link {...props} to={props.to} className="ButtonLink btn-inverted">{getLabel(context.locale, props.label)}</Link>
);

InvertedButtonLink.contextTypes = {
  locale: PropTypes.string,
};

const ButtonLink = (props, context) => (
  <Link {...props} to={props.to} className="ButtonLink btn-orange">{getLabel(context.locale, props.label)}</Link>
);

ButtonLink.contextTypes = {
  locale: PropTypes.string,
};

export default ButtonLink;



// WEBPACK FOOTER //
// ./src/main/components/output/ButtonLink.js